import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';

import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery'
import data from "../../../../assets/apiRoutes.json";
import PrimaryTab from "./tabs/PrimaryTab";
import SerialNumberTab from "../../common/SerialNumberTab";
import UserDefinedSublotTab from "./tabs/UserDefinedSublotTab";
import LocationsTab from "../../common/LocationsTab";
import UnavailableTab from "../../common/UnavailableTab";
import StatusTab from "./tabs/StatusTab";
import UOMTab from "./tabs/UOMTab";
var skipDataLoading = false;
var reOrderMethodFlag = false;
var perviousItemType = null;
var profile = null;
var currentR_IDENTITY = null;
var currentRATESELECTION = 'N';
var currentCLASSCODE = null;
var currentSUBCLASSCODE = null;

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        CREATIONDATETIME: null,
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'WM',
        RECORDTYPE: 'R',
        R_ITEM: '',
        CustomerName: '',
        R_LOT: '',
        SUBLOTCODE: '',
        DESCRIPTION_1: '',
        DESCRIPTION_2: '',
        R_LOCATION: '',
        STATUS: 'A',
        COMMENT: '',
        DATEINTRODUCED: new Date(),
        DATEAVAILABLE: new Date(),
        DATEEXPIRATION: null,
        RECORD: '',
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        USERDEFINEDCODE_6: '',
        USERDEFINEDCODE_7: '',
        USERDEFINEDCODE_8: '',
        USERDEFINEDCODE_9: '',
        USERDEFINEDCODE_10: '',
        USERDEFINEDREFERENCE_1: '',
        USERDEFINEDREFERENCE_2: '',
        USERDEFINEDREFERENCE_3: '',
        USERDEFINEDREFERENCE_4: '',
        USERDEFINEDREFERENCE_5: '',
        USERDEFINEDREFERENCE_6: '',
        USERDEFINEDREFERENCE_7: '',
        USERDEFINEDREFERENCE_8: '',
        USERDEFINEDREFERENCE_9: '',
        USERDEFINEDREFERENCE_10: '',
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        ON_HAND: 0,
        IN_ORDERED: 0,
        OUT_ORDERED: 0,
        IN_RECEIVING: 0,
        OUT_SHIPPED: 0,
        IN_BACKORDER: 0,
        OUT_BACKORDER: 0,
        IN_UNAVAILABLE: 0,
        OUT_UNAVAILABLE: 0,
        IN_FUTURE: 0,
        OUT_FUTURE: 0,
        AVAILABLE: 0,
        NETAVAILABLE: 0,
        UNITVOLUMEQUANTITY: null,
        UNITAREAQUANTITY: null,
        UNITVALUEQUANTITY: null,
        NETWEIGHT: null,
        GROSSMINUSNET: null,
        GROSSWEIGHT: null,
        UNITVOLUMEUOM: null,
        UNITAREAUOM: null,
        UNITVALUEUOM: null,
        NETWEIGHTUOM: null,
        GROSSWEIGHTUOM: null,
        INVENTORYUNITNOTUSED: 1,
        PIECESPERUNITQUANTITY: '',
        UNITSPERPACKAGEQUANTITY: '',
        PACKAGESPERSHIPPINGUNITQTY: '',
        INVENTORYUNITUOM: '',
        PIECESPERUNITUOM: '',
        UNITSPERPACKAGEUOM: '',
        PACKAGESPERSHIPPINGUNITUOM: '',
        STORAGEBILLINGSTARTDATE: '',
        STORAGEBILLINGENDDATE: '',
        STORAGEBILLEDDATE_LAST: '',
        PREVSTORAGEBILLEDDATE_LAST: '',
        STORAGEBILLEDDATE_NEXT: '',
        PREVSTORAGEBILLEDDATE_NEXT: '',
        RECURRINGSTORAGE: 'Y',
        SIZE_1: '',
        SIZE_2: '',
        ALTERNATEID: '',
        R_CONSIGNEE: '',
        R_PROFILE: '',
        R_IDENTITY: null,
    };


    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            if (formFields.ROWID == "00000000-0000-0000-0000-000000000000") {
                await insertItem();
            }
            else {
                await updateItem();
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const insertItem = async () => {
        try {
            const url = "wm/SubLot/InsertSublot";
            let fields = formFields;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);

            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                setformFields(prevFields => ({
                    ...prevFields,
                    ROWID: response.data.ROWID,
                    RECORD: response.data.RECORD
                }));
                notify(
                    {
                        message: "Sublot Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                notify(
                    {
                        message: "Could not create Sublot. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateItem = async () => {
        try {
            const url = "wm/sublot/UpdateSublot";
            let fields = formFields;
            fields.LASTUPDATEDATETIME = null;
            fields.DATEINTRODUCED = GetFormatedDateWithTime(formFields.DATEINTRODUCED);
            fields.DATEAVAILABLE = GetFormatedDateWithTime(formFields.DATEAVAILABLE);
            fields.DATEEXPIRATION = GetFormatedDateWithTime(formFields.DATEEXPIRATION);
            fields.USERDEFINEDDATE_1 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_1);
            fields.USERDEFINEDDATE_2 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_2);
            fields.USERDEFINEDDATE_3 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_3);
            fields.USERDEFINEDDATE_4 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_4);
            fields.USERDEFINEDDATE_5 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_5);
            fields.USERDEFINEDDATE_6 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_6);
            fields.USERDEFINEDDATE_7 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_7);
            fields.USERDEFINEDDATE_8 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_8);
            fields.USERDEFINEDDATE_9 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_9);
            fields.USERDEFINEDDATE_10 = GetFormatedDateWithTime(formFields.USERDEFINEDDATE_10);
            fields.STORAGEBILLINGSTARTDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGSTARTDATE);
            fields.STORAGEBILLINGENDDATE = GetFormatedDateWithTime(formFields.STORAGEBILLINGENDDATE);
            fields.STORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_LAST);
            fields.PREVSTORAGEBILLEDDATE_LAST = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_LAST);
            fields.STORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.STORAGEBILLEDDATE_NEXT);
            fields.PREVSTORAGEBILLEDDATE_NEXT = GetFormatedDateWithTime(formFields.PREVSTORAGEBILLEDDATE_NEXT);
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data || !response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Sublot Updated",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setIsFormSubmitted(false);
            }


        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                var hasWarning = false;
                var hasConfirmation = false;
                var errorMessage = "";
                var errorsArray = [];

                for (let i = 0; i < error.response.data.ERRORS.length; i++) {

                    if (error.response.data.ERRORS[i].startsWith("[ItemTypeWarning]")) {
                        hasWarning = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeWarning]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else if (error.response.data.ERRORS[i].startsWith("[ItemTypeConfirmation]")) {
                        hasConfirmation = true;
                        errorMessage = error.response.data.ERRORS[i];
                        errorMessage = errorMessage.replace('[ItemTypeConfirmation]', '');
                        errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    }
                    else {
                        errorsArray.push(error.response.data.ERRORS[i]);
                    }
                }

                if (errorsArray.length > 0) {
                    const errorHtml = errorsArray.map(err => `<div>${err}</div>`).join('');
                    custom({
                        title: "Errors",
                        messageHtml: errorHtml,
                        buttons: [{ text: "OK", onClick: () => { } }]
                    }).show();
                }
                else {
                    if (hasWarning) {
                        alert(errorMessage, "Warning");
                        setformFields(prevFields => ({
                            ...prevFields,
                            ITEMTYPE: perviousItemType
                        }));

                    }
                    else if (hasConfirmation) {

                    }
                }
            }
            else {
                notify(
                    {
                        message: "Could not create Sublot. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };



    const primaryFormLookupsLoad = () => {
        primaryFormLoad();
    }

    const primaryFormLoad = () => {
        loadLookupFromStaticData(formRefs, "ITEMTYPE", [{ id: 'I', name: "Item" }, { id: 'L', name: "Item/Lot" }, { id: 'S', name: "Item/Lot/Sublot" }, { id: 'U', name: "Item/Lot/Sublot/Unit" }]);
        loadLookupFromStaticData(formRefs, "STATUS", [{ id: 'A', name: "Active" }, { id: 'I', name: "Inactive" }]);
        if (formRefs.current['RECORD']) {
            formRefs.current['RECORD'].instance().option('disabled', true);
        }
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            if (formRefs.current['R_ITEM']) {
                formRefs.current['R_ITEM'].instance().option('disabled', true);
            }
        }
        if (formRefs.current['R_LOT']) {
            formRefs.current['R_LOT'].instance().option('disabled', true);
        }
    }

    const loadLookupFromDataSource2 = (name, dataSource, valueExpr, displayExpr) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
        }
        else {
            console.log('not found control:');
        }
    };


    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };
    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableControlsForNewRecord();
        }

    };

    const DeleteClick = async () => {
        let result = confirm("<i>Are your sure you want to delete this record?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/sublot/DeleteSublot'}`, formFields.ROWID, {
                        headers: {
                            'Content-Type': 'application/json',
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`
                        },
                    });
                    if (!response.data.ERRORS.length > 0) {
                        notify(
                            {
                                message: "Sublot Deleted",
                                width: 100,
                            },
                            'success',
                            3000,
                        );
                        setLoadPanelVisible(false);
                        history.push('/wm/codes/sublot-data-entry');
                    }
                }
                catch (error) {
                    setLoadPanelVisible(false);
                    if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                        const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                        custom({
                            title: "Errors",
                            messageHtml: errorHtml,
                            buttons: [
                                {
                                    text: "Yes",
                                    onClick: () => {
                                        MarkSublotAsInactive();
                                    }
                                },
                                {
                                    text: "Cancel",
                                    onClick: () => {
                                    }
                                }
                            ]
                        }).show();
                    }
                    else {
                        notify(
                            {
                                message: "Could not delete Sublot. An error occurred",
                                width: 100,
                            },
                            'error',
                            3000,
                        );
                    }
                }
            }
        })
    }

    const MarkSublotAsInactive = async () => {
        setLoadPanelVisible(true);
        try {
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${'wm/sublot/MarkSublotAsInactive'}`, formFields.ROWID, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Sublot Marked as In Active",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setLoadPanelVisible(false);
                history.push('/wm/codes/sublot-data-entry');
            }
            else {
                setLoadPanelVisible(false);
                const errorHtml = response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
        }
        catch (error) {
            setLoadPanelVisible(false);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                notify(
                    {
                        message: "Could Not Mark Sublot as In Active. An error occurred",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }
        }
    }

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        history.push('/wm/codes/add-sublot');
        EnableControlsForNewRecord();
    }

    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/sublot/GetSublotDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data.Item1;
                console.log("Response Item1:\n", JSON.stringify(res.data.Item1, null, 2));
                profile = res.data.Item2;
                if (profile) {
                    setformFields(prevFields => ({
                        ...prevFields,
                        R_ITEM: profile.rowid,
                    }));
                }
                if (responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;

                    // Set customer value in SelectBox if R_IDENTITY exists
                    // Wait for form to be fully loaded and customer data source to be ready
                    setTimeout(() => {
                        if (responseData.R_IDENTITY && formRefs.current["R_IDENTITY"]) {
                            const identityInstance = formRefs.current["R_IDENTITY"]?.instance?.();
                            if (identityInstance) {
                                // Ensure data source is loaded first
                                const dataSource = identityInstance.option('dataSource');
                                if (dataSource) {
                                    identityInstance.option('value', responseData.R_IDENTITY);
                                } else {
                                    // If data source not ready, try again after a delay
                                    setTimeout(() => {
                                        const retryInstance = formRefs.current["R_IDENTITY"]?.instance?.();
                                        if (retryInstance) {
                                            retryInstance.option('value', responseData.R_IDENTITY);
                                        }
                                    }, 500);
                                }
                            }
                        }
                    }, 300);
                }
                else {
                    console.error('Failed to get item data');
                }
            });


        } catch (error) {
            console.error('Error failed to get item data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
    }, []);

    const goBack = () => {
        history.push("/wm/codes/sublot-data-entry");
    };

    const EnableControlsForNewRecord = () => {


    }

    const GetItemDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/wm/Item/GetItemDataByProfileRowId?rowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                var responseData = response.data.Item1;
                profile = response.data.Item2;

                if (responseData) {
                    responseData.ROWID = '00000000-0000-0000-0000-000000000000';
                    responseData.RECORD = '';
                    responseData.CREATIONDATETIME = null;
                    responseData.LASTUPDATEDATETIME = null;
                    responseData.CREATIONUSERID = '';
                    responseData.LASTUPDATEUSERID = '';
                    responseData.COMPANYID = '';
                    responseData.MODULE = 'WM';
                    responseData.RECORDTYPE = 'R';
                    responseData.ON_HAND = 0;
                    responseData.IN_ORDERED = 0;
                    responseData.OUT_ORDERED = 0;
                    responseData.IN_RECEIVING = 0;
                    responseData.OUT_SHIPPED = 0;
                    responseData.IN_BACKORDER = 0;
                    responseData.OUT_BACKORDER = 0;
                    responseData.IN_UNAVAILABLE = 0;
                    responseData.OUT_UNAVAILABLE = 0;
                    responseData.IN_FUTURE = 0;
                    responseData.OUT_FUTURE = 0;
                    responseData.AVAILABLE = 0;
                    responseData.NETAVAILABLE = 0;

                    // if customer has been entered, assume the user has already entered some information
                    // so only overwrite a field with the default value if the field is null}
                    // if customer has not been enterd then assign each field value of item profile to current item record}
                    if (formFields.R_IDENTITY != null && formFields.R_IDENTITY !== "" && formFields.R_IDENTITY !== "00000000-0000-0000-0000-000000000000") {
                        for (const key in formFields) {
                            if (formFields[key] != null && formFields[key] != '') {

                                responseData[key] = formFields[key];
                            }
                        }
                    }

                    responseData.DATEINTRODUCED = new Date();
                    responseData.DATEAVAILABLE = new Date();
                    responseData.STORAGEBILLINGSTARTDATE = new Date();
                    responseData.STORAGEBILLINGENDDATE = new Date(2999, 11, 31);
                    responseData.INVENTORYUNITNOTUSED = 1;
                    setformFields(responseData);

                    currentR_IDENTITY = responseData.R_IDENTITY;
                    currentRATESELECTION = responseData.RATESELECTION;
                    currentCLASSCODE = responseData.CLASSCODE;
                    currentSUBCLASSCODE = responseData.SUBCLASSCODE;

                }
            }
            else {
                console.error('Failed to get item profile data');
            }
        } catch (error) {
            console.error('Error fetching item profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_ITEM") {
            if (value && typeof value === 'object' && value.Customer !== undefined) {
                setformFields(prev => ({ ...prev, CustomerName: value.Customer || '' }));
            } else if (value && typeof value === 'object' && value?.selectedItem?.Customer !== undefined) {
                setformFields(prev => ({ ...prev, CustomerName: value?.selectedItem?.Customer || '' }));
            } else if (!value) {
                setformFields(prev => ({ ...prev, CustomerName: '' }));
            }
            var rowid = props.id;
            let currentItem = formRefs.current['R_ITEM']?.instance()?.option('value');
            if(currentItem && (rowid == null || rowid == undefined || rowid == '')) {
                if (formRefs.current['R_LOT']) {
                    formRefs.current['R_LOT'].instance().option('disabled', false);
                }
                const lotInstance = formRefs.current["R_LOT"]?.instance?.();
                if (lotInstance) {
                    lotInstance.option("value", null);
                }
                const profileInstance = formRefs.current["R_PROFILE"]?.instance?.();
                if (profileInstance) {
                    profileInstance.option("value", e?.selectedvalue?.profile);
                }
                setformFields(prevFields => ({
                    ...prevFields,
                    R_LOT: '',
                }));
                return;
            }
            else {
                if(rowid == null || rowid == undefined || rowid == ''){
                    if (formRefs.current['R_LOT']) {
                        formRefs.current['R_LOT'].instance().option('disabled', true);
                    }
                    const lotInstance = formRefs.current["R_LOT"]?.instance?.();
                    if (lotInstance) {
                        lotInstance.option("value", null);
                    }
                         setformFields(prevFields => ({
                        ...prevFields,
                        R_LOT: '',
                    }));
                }
            }
        }
        
        
        if (name == "R_LOT") {
            // let currentItem = formRefs.current['R_ITEM']?.instance().option('value');
            // if(!currentItem) {
            //     alert("Please select a item first");
            //     if (formRefs.current['R_LOT']) {
            //         const lotInstance = formRefs.current['R_LOT']?.instance?.();
            //         if (lotInstance) {
            //             lotInstance.option('value', null);
            //         }
            //     }
            //     // Also update formFields state to keep it in sync
            //     setformFields(prevFields => ({
            //         ...prevFields,
            //         R_LOT: '',
            //     }));
            //     return;
            // }

        }
        
        if (name === "GROSSMINUSNET") {
            const netWeight = parseFloat(formRefs.current['NETWEIGHT']?.instance().option('value')) || 0;
            const tareWeight = parseFloat(value) || 0;
            const calculatedValue = netWeight + tareWeight;

            if (formRefs.current['GROSSWEIGHT']) {
                formRefs.current['GROSSWEIGHT'].instance().option('value', calculatedValue);
            }
        }

        if (name === "NETWEIGHT") {
            const tareWeight = parseFloat(formRefs.current['GROSSMINUSNET']?.instance().option('value')) || 0;
            const netWeight = parseFloat(value) || 0;
            const calculatedValue = tareWeight + netWeight;

            if (formRefs.current['GROSSWEIGHT']) {
                formRefs.current['GROSSWEIGHT'].instance().option('value', calculatedValue);
            }
        }

    });

    const handleStatusFieldChange = (name, value) => {
    }
    const statusFormLookupsLoad = () => {

    }
    const handleUOMFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "INVENTORYQUANTITYSOURCE", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }, { id: 'S', name: "Sublot" }]);
        loadLookupFromStaticData(formRefs, "WEIGHTBASISFLAG", [{ id: 'I', name: "Item" }, { id: 'L', name: "Lot" }, { id: 'S', name: "Sublot" }, { id: 'U', name: "Unit" }]);
        loadLookupFromStaticData(formRefs, "RECEIPTUOMDEFAULT", [{ id: 'I', name: "Inventory Unit" }, { id: 'P', name: "Pieces" }, { id: 'P', name: "Packages (eg. Pallets)" }, { id: 'H', name: "Shipment (eg. Container)" }]);
        loadLookupFromStaticData(formRefs, "SHIPMENTUOMDEFAULT", [{ id: 'I', name: "Inventory Unit" }, { id: 'P', name: "Pieces" }, { id: 'K', name: "Packages (eg. Pallets)" }, { id: 'H', name: "Shipment (eg. Container)" }]);
        loadLookupFromStaticData(formRefs, "RFRECEIPTVALIDATION", [{ id: 'Y', name: "EDI import to insert Serial # records for valdation by RF program" }, { id: 'N', name: "EDI import to gonre Serial # records or Serial #s do not exist" }]);
        loadLookupFromStaticData(formRefs, "RFSHIPMENTVALIDATION", [{ id: 'Y', name: "EDI import to insert Serial # records for valdation by RF program" }, { id: 'N', name: "EDI import to gonre Serial # records or Serial #s do not exist" }]);
        loadLookupFromStaticData(formRefs, "RECURRINGSTORAGE", [{ id: 'Y', name: "Yes, Always Generate Recurring Storage Charges" }, { id: 'A', name: "Yes, Generate Recurring Storage Charges, But Set The Flag to No When On Hand Goes To Zero" }, { id: 'N', name: "No, Never Generate Recurring Storage Charges" }]);
        let calculatedValue = formFields['GROSSWEIGHT'] - formFields['NETWEIGHT'];
        if (formRefs.current['GROSSMINUSNET']) {
            formRefs.current['GROSSMINUSNET'].instance().option('value', calculatedValue);
        }

        if (formRefs.current['INVENTORYUNITNOTUSED']) {
            formRefs.current['INVENTORYUNITNOTUSED'].instance().option('value', 1);
        }
       
    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>

                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            SubLot Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" disabled={props.isOpenAsPopUp} />
                                </Item>
                            </Toolbar>
                            
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="UOM" >
                                    <UOMTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} handleUOMFormLoad={handleUOMFormLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Status">
                                    <StatusTab formFields={formFields} setformFields={setformFields} handleStatusFieldChange={handleStatusFieldChange} statusFormLookupsLoad={statusFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedSublotTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Locations">
                                    <LocationsTab itemRowId={formFields.ROWID} type='sublot' />
                                </TabItem>
                                <TabItem title="Unavailable">
                                    <UnavailableTab itemRowId={formFields.ROWID} type='sublot' />
                                </TabItem>
                                <TabItem title="Serial #" >
                                    <SerialNumberTab sourceId={formFields.ROWID} formRefs={formRefs} type='sublot' />
                                </TabItem>

                            </TabPanel>

                        </form>
                    </div>

                </div>
            </div>

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
